import { Action, ConfigDashboardTypesPayload, ConfigDashboardTypesState } from "../../types"

const initialState:ConfigDashboardTypesState = {
    configDashboardTypes:[],
    activeOption:""
}
export function configTypeReducer(state:ConfigDashboardTypesState=initialState,action:Action<ConfigDashboardTypesPayload>):ConfigDashboardTypesState{
    switch(action.type){
        case "resetConfigDashboardTypes":
            return {...state,...action.payload};
        case "setActiveConfigType":
            return {
                ...state,
                "activeOption":action.payload.activeOption ?? ""
            };
        case "clearConfigDashboardTypes":
            return {...initialState};
    }
    return state
}